import { PageNavigation, StateHandlerCallback } from "./PageNavigation";

export class NullPageNavigation implements PageNavigation {
    performSaveAndNavigateNext(): Promise<void> {
        return Promise.resolve();
    }

    setAdditionalParams(_val: string | object): void { /* do nothing */ }

    setStateHandler(_callback: StateHandlerCallback): void { /* do nothing */ }
}
